// src/components/Chatbot.js
import React, { useState, useEffect } from 'react';
import './chatbot.css';
import chatbot from '../assets/chatbot.png'; 

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);

  const questionsAnswers = {
    "What is this extension?": "Our extension helps you control sensitive information by detecting and alerting you in real-time when personal , medical, financial  data is exposed.",
    "How do I install the extension?": "You can install the extension from the Chrome Web Store. Simply search for our extension, click 'Add to Chrome,' and follow the instructions.",
    "Can it detect all sensitive data?": "Yes, it can detect predefined sensitive information based on the extension's configurations.",
    "Is this extension free?": "Yes, our extension offers a free version with core features. Premium features such as advanced analytics are available in the paid version.",
    "What happens if I ignore an alert?": "If you ignore an alert, the data will be sent only to the destination you've approved, ensuring that your action is deliberate.",
    "What kind of sensitive data does it detect?": "It detects personal details like emails, phone numbers, payment details, and even company-specific information to prevent unauthorized sharing.",
    "What is the purpose of this extension?": "It helps to ensure data protection by detecting and alert sensitive information.",
    "Can I customize the settings?": "Yes, the extension allows full customization of alerts, so you can choose when and what type of alerts you receive..",
    "Is my data secure?": "Yes, we do not collect or store any of your data.",
    "Does it work offline?": "Yes, the extension works offline as it runs locally in your browser.",
    "Can I track which websites are requesting sensitive information?": "Yes, the extension provides detailed logs showing which websites are trying to access your sensitive data, keeping you informed.",
    "Can I disable the detection temporarily?": "Yes, you can toggle the extension on or off from the toolbar.",
    "Does it support multiple languages?": "Currently, it supports English, but more languages will be added soon.",
    "Is there a dashboard where I can view my data alerts?": "Absolutely! Our extension includes a personalized dashboard where you can track all the alerts, customize settings, and view logs.",
    "Does it work with other forms besides input fields?": "Right now, it works specifically with input fields.",
    "Can I export my alert data?": "Yes, you can export all alert logs and analysis reports from your dashboard for further review and security audits.",
    "How does the real-time alert system work?":"The real-time alert system monitors your activities and notifies you instantly when sensitive data like PII is detected in your inputs."
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setMessages([{ sender: 'bot', text: 'Hello! How can I assist you? You can also choose from these questions:', suggestions: Object.keys(questionsAnswers) }]);
      }, 1000);
    }
  }, [isOpen]);

  const toggleChat = () => setIsOpen(!isOpen);

  const handleSendMessage = () => {
    if (input.trim()) {
      const userMessage = input;
      setMessages([...messages, { sender: 'user', text: userMessage }]);
      setInput('');
      setIsTyping(true);

      setTimeout(() => {
        const botResponse = questionsAnswers[userMessage] || null;
        if (botResponse) {
          setMessages((prevMessages) => [
            ...prevMessages,
            { sender: 'bot', text: botResponse }
          ]);
        } else {
          setMessages((prevMessages) => [
            ...prevMessages,
            { sender: 'bot', text: "I'm sorry, I don't have an answer for that. Try one of these questions:", suggestions: Object.keys(questionsAnswers) }
          ]);
        }
        setIsTyping(false);
      }, 1500);
    }
  };

  const handleSuggestionClick = (question) => {
    setInput(question);
    handleSendMessage();
  };

  return (
    <div className="chatbot-container">
      <div className={`chatbot-icon ${isOpen ? 'hidden' : ''}`} onClick={toggleChat}>
        <img src={chatbot} alt="Chatbot Icon" className="chat-icon" />
      </div>
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <h4>Welcome to EQ of AI</h4>
            <button onClick={toggleChat}>✖</button>
          </div>
          <div className="chat-body">
            {messages.map((msg, index) => (
              <div key={index} className={`message ${msg.sender}`}>
                {msg.text}
                {msg.suggestions && (
                  <div className="suggestions">
                    {msg.suggestions.map((suggestion, i) => (
                      <button key={i} className="suggestion-btn" onClick={() => handleSuggestionClick(suggestion)}>
                        {suggestion}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {isTyping && <div className="typing-indicator">Bot is typing...</div>}
          </div>
          <div className="chat-footer">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask a question..."
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
